









































































































import ResponsiveImage from '@/components/common/Image.vue';
import RichTextDisplay from '@/components/common/RichTextDisplay.vue';
import SocialMediaButtons from '@/components/common/SocialMediaButtons.vue';
import CampaignQuery from '@/graphql/queries/campaign.gql';
import request from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    RichTextDisplay,
    SocialMediaButtons,
    ResponsiveImage,
  },
})
export default class ShowCampaign extends Vue {
  public id: string = '';
  public isOver: boolean = false;
  public isFunded: boolean = false;
  public recentContributions!: Array<{
    sourceName: string;
    amount: number;
    createdAt: Date;
  }>;
  public campaign: {
    id: string;
    name: string;
    description: string;
    goal: number;
    raised: number;
    endDateTime: Date;
    heroImage: string;
    contributions: Array<{
      sourceName: string;
      amount: number;
      createdAt: Date;
    }>;
  } = {} as any;

  public mounted() {
    this.id = this.$route.query.id;

    request(CampaignQuery, { id: this.id })
      .then(response => {
        if (!response || !response.data) {
          console.error('No campaign returned');
          return;
        }

        this.campaign = response.data.campaign;

        if (!this.campaign) {
          this.$router.push('/');
        }

        document.title = this.campaign.name;

        this.getRecentContributions();

        if (Date.now() > +new Date(this.campaign.endDateTime)) {
          this.isOver = true;
        }
        if (this.campaign.raised >= this.campaign.goal) {
          this.isFunded = true;
        }
      })
      .catch(console.error);
  }

  public formatDate(date: string | Date) {
    return new Date(date).toLocaleDateString(undefined, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  public formatPrice(price: number) {
    return (price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  public calculatePercentage() {
    return (this.campaign.raised / this.campaign.goal) * 100 || 0;
  }

  public showName(name: string) {
    if (!name) {
      return 'Anonymous';
    }

    const firstSpace = name.indexOf(' ');
    return firstSpace > -1 ? name.substr(0, firstSpace) : name;
  }

  private getRecentContributions() {
    if (this.campaign.contributions && this.campaign.contributions.length) {
      this.recentContributions = this.campaign.contributions
        .sort((a, b) => +new Date(b.createdAt) - +new Date(a.createdAt))
        .slice(0, 5);
    }
  }
}
